import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import "./MoreUpdate2.css";
import BlogImg1 from "../../assets/blog/blogImg1.png";
import BlogImg2 from "../../assets/blog/blogImg2.png";
import BlogImg3 from "../../assets/blog/blogImg3.png";

const moreUpdatesData = [
  {
    id: 1,
    title: "A Guide to Mastering Investment Tracking",
    image: BlogImg1,
  },
  {
    id: 2,
    title: "Start Planning for Retirement Today",
    image: BlogImg2,
  },
  {
    id: 3,
    title: "Regain Control with Debt Management",
    image: BlogImg3,
  },
];

const MoreUpdate2 = () => {
  return (
    <section className="more-update-section">
      <div className="more-update-container">
        <h2 className="more-update-title">More Update</h2>

        <div className="more-update-grid">
          {moreUpdatesData.map((blog) => {
            // Generates URL path and safely removes any trailing hyphens
            const blogPath = `/blog/${blog.title
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/(^-|-$)+/g, "")}`;

            return (
              <Link
                to={blogPath}
                className="mu-card"
                key={blog.id}
                onClick={() => window.scrollTo(0, 0)}
                style={{ textDecoration: "none" }}
              >
                <div className="mu-img-wrapper">
                  <img src={blog.image} alt={blog.title} className="mu-img" />
                  <div className="mu-gradient-overlay"></div>
                </div>

                <div className="mu-content">
                  <h3 className="mu-card-title">{blog.title}</h3>
                  <ArrowUpRight className="mu-card-icon" size={20} />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MoreUpdate2;
